export const TYPE_TEXT = `Enroll in a course to earn transferable college credits. 
Audit the course to learn at your own pace without exams, 
grades, or any impact on your academic record.`

export const AUDITED_TEXT = 'You’ve already audited this course. Enroll to earn transferable college credits.'

export const DURATION_TEXT = `The estimated time commitment for the 14-week Standard course is 10 hours per week. 
For the 7-week Intensive, it’s 20 hours per week.`
